// extracted by mini-css-extract-plugin
export default {"wrapperStyle":"Wrapper_wrapperStyle__Km-1z"};